import React from "react";
import { FormSectionElements } from "../../entities/formTemplateDataType";

interface Props {
  isEng: boolean;
  field: FormSectionElements
  disabled?: boolean;
  onClick: () => void;
}

const PdfButtonComponent: React.FC<Props> = ({ isEng, disabled, onClick }) => {
  return (
    <button
      className="ontario-button ontario-button--secondary"
      type="button"
      disabled={disabled}
      onClick={onClick}
    >
      {isEng ? "Download PDF" : "Enregistrer et continuer plus tard"}
    </button>
  );
};

export default PdfButtonComponent;
